import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcnComponents/ui/tooltip";
import { HelpCircle } from "lucide-react";
import React from "react";
import { TableCell } from "../../../shadcnComponents/ui/table";
import { cn } from "../../../lib/utils";
import { cva, VariantProps } from "class-variance-authority";

interface MetricsNumberCardProps {
  count: number | string;
  title?: string;
  info?: string;
  tag?: string;
}

export const MetricsNumberCard: React.FC<MetricsNumberCardProps> = ({
  count,
  title,
  info,
  tag,
}) => {
  return (
    <>
      <div className="relative rounded-lg bg-[#2a2a2a] ">
        <div className="p-4 text-center flex flex-col justify-center">
          {
            <div className="absolute top-0 right-0 mr-2 mt-2 flex gap-1 items-center">
              {info && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <HelpCircle size={14} color="#919191" />
                    </TooltipTrigger>
                    <TooltipContent className="bg-[#232323] border-none">
                      <p className="text-[#919191] font-[Inter] text-[12px] not-italic font-normal leading-[20px]">
                        {info}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
          }
          <h3 className="text-2xl font-bold" title={`${tag ? tag : ""}`}>
            {count}
          </h3>
          {title && (
            <p className="self-stretch text-[#919191] font-[Inter] text-[12px] not-italic font-normal leading-[20px]">
              {title}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export const TableBodyCell = ({
  children,
  className,
  title,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  props?: React.TdHTMLAttributes<HTMLTableCellElement>;
  title?: string;
}) => {
  return (
    <TableCell
      title={title}
      className={cn("text-center px-5 py-4", className)}
      {...props}
    >
      {children}
    </TableCell>
  );
};

const RoundedPillTagVariant = cva(
  "rounded-full px-3 py-1.5 border-2 font-[Inter] text-xs not-italic font-medium leading-[normal] capitalize",
  {
    variants: {
      variant: {
        image: "border-[#257BFA99] text-[#B4D2FF] bg-[#257BFA1F]",
        video: "border-[#FF730099] text-[#FF7300] bg-[#FF73001F]",
        text: "border-[#FF6DE799] text-[#FFDEFA] bg-[#FF6DE71F]",
        feed: "border-[#D7B825] text-[#D7B825] bg-[#D7B8251F]",
        repost: "border-[#D7B825] text-[#D7B825] bg-[#D7B8251F]",
        carousel: "border-[#D7B82599] text-[#FFF4C2] bg-[#D7B8251F]",
      },
    },
    defaultVariants: {
      variant: "text",
    },
  }
);

export const RoundedPillTag = ({
  children,
  variant = "text",
}: {
  children: React.ReactNode | string;
} & VariantProps<typeof RoundedPillTagVariant>) => {
  return (
    <div className={cn(RoundedPillTagVariant({ variant }))}>{children}</div>
  );
};
